<template>
  <div class="empty-state">
    <div class="empty-state__visual" :style="visualStyle" aria-hidden="true">
      <i :class="icon"></i>
    </div>
    <div class="empty-state__title">{{ title }}</div>
    <div v-if="description" class="empty-state__description">{{ description }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    title: {
      type: String,
      default: "暂无数据"
    },
    description: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "el-icon-box"
    },
    iconSize: {
      type: [Number, String],
      default: 44
    }
  },
  computed: {
    visualStyle() {
      return {
        width: this.formatSize(this.iconSize),
        height: this.formatSize(this.iconSize),
        fontSize: this.formatSize(this.iconSize)
      }
    }
  },
  methods: {
    formatSize(value) {
      return typeof value === "number" ? `${value}px` : value
    }
  }
}
</script>

<style scoped lang="less">
.empty-state {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  text-align: center;
}

.empty-state__visual {
  max-width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary, #5A5F6B);
  background: var(--bg-tag, #F0EDE8);
  border-radius: 4px;
  line-height: 1;

  i {
    display: block;
    font-size: 22px;
  }
}

.empty-state__title {
  max-width: 560px;
  font-size: 15px;
  line-height: 22px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: var(--text-secondary, #5A5F6B);
}

.empty-state__description {
  max-width: 560px;
  margin-top: 8px;
  font-size: 13px;
  line-height: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: var(--text-muted, #9AA0AC);
}
</style>
